import { CustomLink, StyledSpan } from './styles'

export function Link({
  href,
  children,
  title = `${href}`,
  fontSize = 4,
  role = 'link',
  color = 'primary',
  ...linkProps
}) {
  return href ? (
    <CustomLink
      passHref
      href={href}
      className="navigation-menu-items"
      fontSize={fontSize}
      title={title}
      color={color}
      {...linkProps}
    >
      {children}
    </CustomLink>
  ) : (
    <StyledSpan
      className="navigation-menu-items"
      fontSize={fontSize}
      role={role}
      tabIndex={0}
      title={title}
      color={color}
      {...linkProps}
    >
      {children}
    </StyledSpan>
  )
}
